import type { Theme } from '@mui/material'
import { consoleLog } from 'utils/Logger'

function getPageTopSpacing(theme: Theme) {
  return Number(theme.mixins.toolbar.minHeight) + parseInt(theme.spacing(1))
}

function getPageHeight(theme: Theme) {
  return `calc(100vh - ${getPageTopSpacing(theme)}px)`
}

export const isObjectEmpty = (object) => {
  if (!object) return true
  return Object.keys(object).length === 0 && object.constructor === Object
}

export const scrollToViewById = (id: string) => {
  try {
    const div = document.getElementById(id)?.getBoundingClientRect()
    if (div) {
      setTimeout(() => {
        // const rect = elem.getBoundingClientRect();
        const scrollTop = document.documentElement.scrollTop
        const absoluteY = scrollTop + div.top - 100
        window.scrollTo({ top: absoluteY, behavior: 'smooth' })
        // document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' })
      }, 50)
    }
  } catch (e) {
    console.error(e)
  }
}

// export const mergeImageCreatePdf = (images: []) => {
//   const PDFDocument = require('pdfkit')
//   const fs = require('fs')

//   // Create a document
//   const doc = new PDFDocument()

//   // Pipe its output somewhere, like to a file or HTTP response
//   // See below for browser usage
//   doc.pipe(fs.createWriteStream('output.pdf'))

//   // Embed a font, set the font size, and render some text
//   doc.font('fonts/PalatinoBold.ttf').fontSize(25)
//   images.map((image, index) => {
//     doc.addPage().image(image, {
//       fit: [250, 300],
//       align: 'center',
//       valign: 'center',
//     })
//   })
//   doc.end()
// }
export { getPageHeight, getPageTopSpacing }
